import React from 'react';
import { ModuleConfig } from '../../types/ModuleConfig';

const MeetingsList = React.lazy(() => import('./MeetingsList'));
const NewMeetingSummary = React.lazy(() => import('./NewMeetingSummary'));
const MeetingDetails = React.lazy(() => import('./MeetingDetails'));

const meetingSummarizerModule: ModuleConfig = {
  // 🏷️ MODULE IDENTITY
  id: 'meeting-summarizer',
  name: 'Meeting Summarizer',
  description: 'Record, transcribe, and summarize meetings with AI-powered insights',
  version: '1.0.0',
  enabled: true,
  category: 'automation',
  order: 10,
  icon: '🎙️',
  color: '#805AD5',

  // 🛣️ ROUTES
  routes: [
    {
      path: '/meeting-summarizer',
      component: MeetingsList,
      permissions: ['USER']
    },
    {
      path: '/meeting-summarizer/new',
      component: NewMeetingSummary,
      permissions: ['USER']
    },
    {
      path: '/meeting-summarizer/:id',
      component: MeetingDetails,
      permissions: ['USER']
    },
  ],

  // 🧭 NAVIGATION
  navigation: [
    {
      label: 'All Meetings',
      path: '/meeting-summarizer',
      icon: '📋',
      permissions: ['USER']
    },
    {
      label: 'New Meeting',
      path: '/meeting-summarizer/new',
      icon: '➕',
      permissions: ['USER']
    },
  ],

  // 🔒 PERMISSIONS
  permissions: {
    view: ['USER', 'ADMIN', 'MANAGER'],
    create: ['USER', 'ADMIN', 'MANAGER'],
    edit: ['USER', 'ADMIN', 'MANAGER'],
    delete: ['ADMIN', 'MANAGER']
  },

  // ⚡ QUICK ACTIONS
  quickActions: [
    {
      label: 'Record Meeting',
      path: '/meeting-summarizer/new',
      icon: '🎙️',
      description: 'Start recording a new meeting'
    }
  ]
};

export default meetingSummarizerModule;